import { render, staticRenderFns } from "./addCommunity.vue?vue&type=template&id=25e6c0da&scoped=true"
import script from "./addCommunity.vue?vue&type=script&lang=js"
export * from "./addCommunity.vue?vue&type=script&lang=js"
import style0 from "./addCommunity.vue?vue&type=style&index=0&id=25e6c0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6c0da",
  null
  
)

export default component.exports